const RANKING_PRIORITY = ['WEEKLY', 'MONTHLY', 'YEARLY', 'ALL_TIME'];

const RANK_META = {
  WEEKLY:   { label: 'Weekly',   shortLabel: 'W',  cssModifier: 'weekly',   order: 0 },
  MONTHLY:  { label: 'Monthly',  shortLabel: 'M',  cssModifier: 'monthly',  order: 1 },
  YEARLY:   { label: 'Yearly',   shortLabel: 'Y',  cssModifier: 'yearly',   order: 2 },
  ALL_TIME: { label: 'All-Time', shortLabel: 'AT', cssModifier: 'alltime',  order: 3 },
  // Contest rankings are not carried on the novel itself; used when an explicit
  // rank is passed (e.g. ContestDetailPage) so the badge labels consistently.
  CONTEST:  { label: 'Contest',  shortLabel: 'C',  cssModifier: 'contest',  order: 4 },
};

/**
 * Get the best (most relevant) ranking from a novel's rankings array.
 * Priority: WEEKLY > MONTHLY > YEARLY > ALL_TIME.
 * Returns the ranking object { rankType, rankPosition } or null.
 */
export function getBestRanking(rankings) {
  if (!Array.isArray(rankings) || rankings.length === 0) return null;

  for (const type of RANKING_PRIORITY) {
    const match = rankings.find((r) => r.rankType === type);
    if (match) return match;
  }
  return rankings[0] || null;
}

/**
 * Get the best rank position number from a novel's rankings array, or null.
 */
export function getBestRankPosition(rankings) {
  const best = getBestRanking(rankings);
  return best ? best.rankPosition : null;
}

/**
 * Get full display info for the best ranking.
 * Returns { rankPosition, rankType, label, shortLabel, cssModifier } or null.
 */
export function getBestRankingDisplay(rankings) {
  const best = getBestRanking(rankings);
  if (!best) return null;
  const meta = RANK_META[best.rankType] || RANK_META.ALL_TIME;
  return {
    rankPosition: best.rankPosition,
    rankType: best.rankType,
    ...meta,
  };
}

/**
 * Get display info for ALL rankings a novel has, sorted by priority.
 * Returns array of { rankPosition, rankType, label, shortLabel, cssModifier }.
 */
export function getAllRankingsDisplay(rankings) {
  if (!Array.isArray(rankings) || rankings.length === 0) return [];
  return rankings
    .filter((r) => r.rankType && RANK_META[r.rankType])
    .map((r) => ({
      rankPosition: r.rankPosition,
      rankType: r.rankType,
      ...RANK_META[r.rankType],
    }))
    .sort((a, b) => a.order - b.order);
}

export { RANK_META };
